<template>
  <v-card class="mb-5">
    <v-card-title v-if="index >= 0" class="d-flex flex-row">
      <h4>Student {{index+1}}</h4>
      <v-btn class="ml-auto" @click="deleteStudent(index)" icon>
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-text-field label="First Name" v-model="student.firstName" :rules="[rules.required]"></v-text-field>
      <v-text-field label="Last Name" v-model="student.lastName" :rules="[rules.required]"></v-text-field>
      <v-text-field
        label="Gmail for Google Meet"
        hint="Please use a Gmail for best experience since we use Google Meet for virtual lessons"
        v-model="student.email"
      ></v-text-field>
      <v-select
        v-model="student.grade"
        :items="gradeItems"
        item-value="value"
        item-text="text"
        label="Grade"
        :clearable="true"
      ></v-select>

      <v-select
        v-model="student.relationship"
        :items="relationshipItems"
        item-value="value"
        label="Relationship"
        :clearable="true"
      ></v-select>

      <v-menu
        ref="`showDob${index}`"
        v-model="showDobMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        min-width="290px"
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="student.dob"
            label="Date of Birth"
            v-bind="attrs"
            v-on="on"
            hint="YYYY-MM-DD format"
            clearable
            @click:clear="student.dob = ''"
          ></v-text-field>
        </template>
        <v-date-picker
            ref="picker"
            :max="new Date().toISOString().substr(0, 10)"
            min="1950-01-01"
         v-model="student.dob" 
         @change="showDobMenu = false" 
         no-title scrollable></v-date-picker>
      </v-menu>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    student: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: false
    }
  },
  data: () => ({
    showDobMenu: false,
    gradeItems: [
      // { text: "Pre-K", value: "-1" },
      // { text: "Kindergarden", value: "0" },
      { text: "Grade 1", value: "1" },
      { text: "Grade 2", value: "2" },
      { text: "Grade 3", value: "3" },
      { text: "Grade 4", value: "4" },
      { text: "Grade 5", value: "5" },
      { text: "Grade 6", value: "6" }
      // { text: "Grade 7", value: "7" },
      // { text: "Grade 8", value: "8" },
      // { text: "Grade 9", value: "9" }
    ],
    relationshipItems: [
      { text: "Son", value: "Son" },
      { text: "Daughter", value: "Daughter" },
      { text: "Grandson", value: "Grandson" },
      { text: "Granddaughter", value: "Granddaughter" },
      { text: "Niece", value: "Niece" },
      { text: "Nephew", value: "Nephew" },
      { text: "Other", value: "Other" }
    ],
    rules: {
      required: value => !!value || "This field is required",
    }
  }),
  watch: {
      showDobMenu(val){
        val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
      }
  },
  methods:{
      deleteStudent(studentIndex){
          this.$emit('delete', studentIndex);
      }
  }
};
</script>

<style>
</style>